import z from "zod/v4";

export const getTrackingPagesMetrics = {
  name: "getTrackingPagesMetrics",
  input: z.object({
    numUnits: z.number().int().nonnegative(),
    startDate: z.date(),
    // Defaults to 1 on the server when omitted. Max 5: matches
    // TRACKING_PAGE_ORDER_ATTRIBUTION's window range and UpsellAnalyticsAttributionFilter.
    attributionDays: z.number().int().min(1).max(5).optional(),
  }),
  output: z.object({
    pages: z.array(
      z.object({
        trackingPageId: z.string(),
        opens: z.number(),
        clicks: z.number(),
        revenue: z.number(),
      }),
    ),
  }),
};
